import { render, staticRenderFns } from "./DeviceIssues.vue?vue&type=template&id=11bc3030&scoped=true"
import script from "./DeviceIssues.vue?vue&type=script&lang=js"
export * from "./DeviceIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bc3030",
  null
  
)

export default component.exports